import React, { useMemo } from 'react';
import { Box, Button, FormControlLabel, MenuItem, TextField, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
// import CalendarIcon from '../CalendarIcon';
import CancelIcon from '@mui/icons-material/Cancel';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { useTheme } from '@mui/material/styles';
// import './ticket.css';
import CustomCheckbox from '../CustomCheckbox';
import { useState } from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteOutline';
import { debounce, errorMessages, filterTrainers, imageValidation } from '../../utils/methods';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { FormInputText } from '../../form-components/FormInputText';
import { useForm } from 'react-hook-form';
import { FormInputDropdown } from '../../form-components/FormInputDropdown';
import FormInputCEditor from '../../form-components/FormInputCEditor';
import { createVOD } from '../../api/ticket';
import { useTranslation } from 'react-i18next';
import { FormInputDate } from '../../form-components/FormInputDate';
import { getPointTrainers } from '../../api/staff';
import { FormInputSearch } from '../../form-components/FormInputSearch';
import { useToast } from 'use-toast-mui';
import CustomRadioBox from '../CustomRadioBox';
import dayjs from 'dayjs';
import { getValue } from '@testing-library/user-event/dist/utils';
import CloseIcon from '@mui/icons-material/Close';
import { sportOptions } from '../../constants/constants';

const options = [
  {
    label: '1-on-1',
    value: 'PRIVATE_LESSON',
  },
  {
    label: 'Online',
    value: 'ONLINE_LESSON',
  },
  {
    label: 'Group',
    value: 'GROUP_LESSON',
  },
];

function CreateVOD() {
  const theme = useTheme();
  const methods = useForm();
  const toast = useToast();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { handleSubmit, control, setValue, watch, reset, getValues } = methods;
  const user = useSelector(state => state.user.user);

  const { t } = useTranslation();
  const [trainers, setTrainers] = useState([]);
  const [ticketData, setTicketData] = useState({
    voucherList: [],
    trainerIdsList: [],
    curList: [{ title: '', outline: '', curImg: {} }],
    finalPrice: '',
  });
  const [selected, setSelected] = useState(null);

  const [usagePeriodType, setUsagePeriodType] = useState(true);
  const [videosOfCourses, setVideosOfCourses] = useState([{ title: '', desc: '', video: { file: null, url: null } }]);

  const handleAddCard = () => {
    setTicketData({
      ...ticketData,
      curList: [...ticketData.curList, { title: '', outline: '', curImg: {} }],
    });
  };

  const handleSelect = id => {
    setSelected(id);
  };

  const handleUploadTicketImages = async e => {
    try {
      const loadedImage = await imageValidation(e.target.files[0]);
      setTicketData({
        ...ticketData,
        voucherList: ticketData.voucherList.map((obj, index) => {
          if (index === selected) {
            return { ...obj, voucherImg: loadedImage };
          }
          return obj;
        }),
      });
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  function handlechage(_, selected) {
    if (selected) {
      const { id, name } = selected;
      setTicketData({
        ...ticketData,
        trainerIdsList: [...ticketData.trainerIdsList, { id, name }],
      });
    }
  }

  function deleteCurImage(index) {
    setTicketData({
      ...ticketData,
      curList: ticketData.curList.map((card, i) => {
        return i === index
          ? {
              ...card,
              curImg: {
                img: true,
              },
              fileName: '',
            }
          : card;
      }),
    });
  }

  function removeTrainer(id) {
    setTicketData({
      ...ticketData,
      trainerIdsList: ticketData.trainerIdsList.filter(tr => tr.id !== id),
    });
  }

  async function uploadImages(e) {
    const files = e.target.files;
    const currentLength = [...ticketData.voucherList, ...files].length;
    const imageLimit = 7;

    if (currentLength > imageLimit) {
      alert(`You can only upload up to ${imageLimit} images.`);
      return;
    }

    const images = [];
    for (const file of files) {
      try {
        const loadedImage = await imageValidation(file);
        images.push({ voucherImg: loadedImage });
      } catch (error) {
        toast.error(errorMessages(error));
      }
    }

    setTicketData({
      ...ticketData,
      voucherList: [...ticketData.voucherList, ...images],
    });
  }

  function setCard(e, index) {
    setTicketData({
      ...ticketData,
      curList: ticketData.curList.map((card, i) => {
        return i === index ? { ...card, [e.target.name]: e.target.value } : card;
      }),
    });
  }

  async function uploadCardImages(e, index) {
    try {
      const loadedImage = await imageValidation(e.target.files[0]);
      setTicketData({
        ...ticketData,
        curList: ticketData.curList.map((card, i) => {
          return i === index
            ? {
                ...card,
                curImg: loadedImage,
                fileName: loadedImage.name,
              }
            : card;
        }),
      });
    } catch (error) {
      toast.error(errorMessages(error));
    }
  }

  const deleteVoucher = index => {
    setTicketData({
      ...ticketData,
      voucherList: ticketData.voucherList.filter((_, i) => i !== index),
    });
  };

  const submit = async values => {
    setLoader(true);
    const { branchName, voucherList, curList, trainerIdsList, ...filterTicketData } = ticketData;
    const { title, outline, curImg, fileName, ...filterValues } = values;

    // Create the filtered data object
    const filteredData = {
      ...filterTicketData,
      ...filterValues,
      saleStartDate: dayjs(filterValues.saleStartDate).format('YYYY-MM-DD'),
      saleEndDate: dayjs(filterValues.saleEndDate).format('YYYY-MM-DD'),
      branchId: user?.branch?.branchId === null ? '' : user?.branch.branchId,
      hasSaleEndDate: values.hasSaleEndDate ?? false,
      classDetail: filterValues.classDetail === undefined ? '' : filterValues.classDetail,
    };
    const formData = new FormData();
    Object.keys(filteredData).forEach(key => {
      if (key === 'hasSaleEndDate') {
        formData.append(key, !filteredData[key]);
      } else {
        formData.append(key, filteredData[key]);
      }
    });

    trainerIdsList.forEach((trainer, index) => {
      formData.append(`trainers[${index}]`, trainer.id);
    });

    voucherList.forEach((voucher, index) => {
      formData.append(`images[${index}]`, voucher.voucherImg);
    });

    curList.forEach((cur, index) => {
      formData.append(`curriculums[${index}].title`, cur.title);
      formData.append(`curriculums[${index}].summary`, cur.outline);
    });

    if (videoFile.file) {
      formData.append('descriptionVideo', videoFile.file);
    } else if (videoFile.url) {
      formData.append('descriptionVideoString', videoFile.url === null ? '' : videoFile.url);
    }

    if (videoThumbnail.file) {
      formData.append('descriptionVideoThumbnail', videoThumbnail.file);
    } else if (videoThumbnail.url) {
      formData.append('descriptionVideoThumbnailString', videoThumbnail.url === null ? '' : videoThumbnail.url);
    }

    formData.append('usagePeriodType', usagePeriodType ? 'MONTH' : 'DAY');
    formData.append('usagePeriod', values.usagePeriod);
    formData.append('discountType', 'RATE');

    formData.append('sportType', values.sports);

    videosOfCourses.forEach((videoOfCourse, index) => {
      formData.append(`videos[${index}].title`, videoOfCourse.title);
      formData.append(`videos[${index}].summary`, videoOfCourse.desc);
      if (videoOfCourse.video.file) {
        formData.append(`videos[${index}].video`, videoOfCourse.video.file);
      } else if (videoOfCourse.video.url) {
        formData.append(
          `videos[${index}].videoString`,
          videoOfCourse.video.url === null ? '' : videoOfCourse.video.url,
        );
      }
    });

    try {
      await createVOD(formData, user.token);
      toast.success(t('VOD created successfully'));
      navigate('/vod');
    } catch (error) {
      toast.error(errorMessages(error));
      setLoader(false);
    }
  };

  useEffect(() => {
    debounce(
      () => {
        setTicketData({
          ...ticketData,
          finalPrice: Math.round(+watch('regularPrice') - +watch('regularPrice') * (+watch('discountRate') / 100)) || 0,
        });
      },
      'set-finalPrice',
      1000,
    );
  }, [watch('regularPrice'), watch('discountRate')]);

  useEffect(() => {
    getPointTrainers(user.branch.branchId, user.token)
      .then(data => {
        setTrainers(data);
      })
      .catch(err => {
        console.log(err);
      });
  }, [user]);

  useMemo(() => {
    const ticket = localStorage.getItem('ticket');
    if (ticket) {
      const ticketP = JSON.parse(ticket);
      const { voucherList, curList } = ticketP;
      setTicketData({
        ...ticketP,
        voucherList: voucherList.filter(voucher => voucher.voucherUrl.startsWith('http')),
        curList: curList.filter(cur => cur.curUrl),
      });
      reset(ticketP);
    }
  }, []);

  const [videoFile, setVideoFile] = useState({ file: null, url: null });
  const [videoThumbnail, setVideoThumbnail] = useState({ file: null, url: null });

  const deleteVideo = e => {
    e.preventDefault();
    setVideoFile({ file: null, url: null });

    const fileInput = document.getElementById('video');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleUploadVideo = async event => {
    try {
      const file = event.target.files[0];
      if (file) {
        const videoURL = URL.createObjectURL(file);
        setVideoFile({ file: file, url: videoURL });
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const deleteVideoThumbnail = e => {
    e.preventDefault();
    setVideoThumbnail({ file: null, url: null });

    const fileInput = document.getElementById('video-thumbnail');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleUploadVideoThumbnail = async event => {
    try {
      const file = event.target.files[0];
      if (file) {
        const imageURL = URL.createObjectURL(file);
        setVideoThumbnail({ file: file, url: imageURL });
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const handleUploadVideoCourse = async event => {
    const input = event.target.id.split('-');
    try {
      const file = event.target.files[0];

      if (file.size > 437 * 1024 * 1024) {
        toast.error('File size exceeds 437MB limit');
        return;
      }

      if (file) {
        const videoURL = URL.createObjectURL(file);

        const videoElement = document.createElement('video');
        videoElement.src = videoURL;

        videoElement.addEventListener('loadedmetadata', () => {
          const videoWidth = videoElement.videoWidth;
          const videoHeight = videoElement.videoHeight;

          if (videoWidth > 1280 || videoHeight > 720) {
            toast.error('Video resolution exceeds 1280x720');
            return;
          }

          setVideosOfCourses(prevValues =>
            prevValues.map((value, index) => {
              if (index === Number(input[1])) {
                return {
                  title: value.title,
                  desc: value.desc,
                  video: { file: file, url: videoURL },
                };
              } else {
                return value;
              }
            }),
          );
        });
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const deleteVideoCourseFile = (event, idx) => {
    event.preventDefault();

    setVideosOfCourses(prevValues =>
      prevValues.map((value, index) => {
        if (index === idx) {
          return { title: value.title, desc: value.desc, video: { file: null, url: null } };
        } else {
          return value;
        }
      }),
    );

    const fileInput = document.getElementById(`videoCourse-${idx}`);
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleChangePeriodType = type => {
    setUsagePeriodType(type);
  };

  const addCourseVideo = () => {
    setVideosOfCourses(prevValues => [...prevValues, { title: '', desc: '', video: { file: null, url: null } }]);
  };

  const deleteCourseVideos = idx => {
    setVideosOfCourses(prevValues => prevValues.filter((_, index) => index !== idx));
  };

  const handleVideoCoursesInfo = event => {
    const input = event.target.name.split('-');
    if (input[0] === 'title') {
      setVideosOfCourses(prevValues =>
        prevValues.map((value, index) => {
          if (index === Number(input[1])) {
            return { title: event.target.value, desc: value.desc, video: value.video };
          } else {
            return value;
          }
        }),
      );
    } else if (input[0] === 'desc') {
      setVideosOfCourses(prevValues =>
        prevValues.map((value, index) => {
          if (index === Number(input[1])) {
            return { title: value.title, desc: event.target.value, video: value.video };
          } else {
            return value;
          }
        }),
      );
    }
  };

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '5px',
        padding: '20px',
        width: '1080px',
      }}>
      <p id="data"></p>
      <ul id="item"></ul>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '20px' }}>
        <Box sx={{ display: 'flex' }}>
          <Link
            style={{
              textDecoration: 'none',
              color: '#3a3a3a',
              display: 'flex',
            }}
            to="/vod">
            <img src="/images/backIcon.svg" alt="backIcon" />

            <Typography sx={{ fontSize: '18px', ml: '8px', fontWeight: '550' }}>{t('Create Pass')}</Typography>
          </Link>
        </Box>
        <Link
          style={{
            fontSize: '14px',
            fontWeight: 550,
            color: theme.palette.primary.main,
            textDecoration: 'none',
          }}
          to="/vod">
          {t('List')}
        </Link>
      </Box>
      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box sx={{ m: 3 }}>
        <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>{t('General Information')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Seller Studio')}
          </Typography>
          <FormInputText
            control={control}
            sx={{ width: '480px', background: '#f1f4f6', color: '#A1A1A1' }}
            disabled
            name="branchName"
            staticValue={user?.branch?.branchName}
            placeholder={t('Studio Name')}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Sports')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('Choose a category')}</MenuItem>}
            name="sports"
            rules={{ required: true }}
            control={control}
            options={sportOptions}
            sx={{ width: '480px', mr: 2 }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Pass Title')}{' '}
          </Typography>
          <FormInputText
            control={control}
            sx={{ width: '480px' }}
            rules={{ required: true }}
            name="ticketName"
            placeholder={t('Type in the pass title')}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            columnGap: 1,
            mt: '18px',
          }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Sales Price')}{' '}
          </Typography>
          <Typography sx={{ fontSize: '12px' }}>{t('List Price')}</Typography>
          <FormInputText
            control={control}
            rules={{ required: true }}
            sx={{ width: '100px', color: '#707070' }}
            placeholder={t('999,999')}
            name="regularPrice"
            type="tel"
          />
          <div
            style={{
              width: '2px',
              height: '31px',
              background: '#ddd',
            }}
          />
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>{t('Discount Rate')}</Typography>
          <FormInputText
            control={control}
            rules={{ required: true }}
            sx={{ width: '57px', color: '#707070' }}
            placeholder="99"
            name="discountRate"
            InputProps={{ min: 5, max: 20 }}
            type="tel"
          />
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>%</Typography>
          <div
            style={{
              width: '2px',
              height: '31px',
              background: '#ddd',
            }}></div>
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>{t('Selling Price')}</Typography>
          <FormInputText
            control={control}
            sx={{ width: '96px', color: '#111' }}
            staticValue={ticketData.finalPrice}
            placeholder={t('$0')}
            type="tel"
            InputProps={{
              readOnly: true,
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Sales Period')}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <FormInputDate
              name="saleStartDate"
              control={control}
              rules={{ required: true }}
              placeholder={t('DD/MM/YYYY')}
              sx={{
                '.css-1x51dt5-MuiInputBase-input-MuiInput-input': {
                  fontSize: '16px',
                },
              }}
              renderInput={params => (
                <TextField
                  color="info"
                  size="small"
                  variant="outlined"
                  {...params}
                  sx={{
                    width: 150,
                    background: '#fff',
                    '.MuiInputBase-root': {
                      paddingRight: '0px',
                    },
                    '.MuiIconButton-root': {
                      marginRight: '0px',
                    },
                    input: {
                      paddingRight: '0px!important',
                    },
                    '& .MuiSvgIcon-root': {
                      fill: '#0F7F85 !important',
                    },
                  }}
                />
              )}
            />
            <p className="m-0">&nbsp;-&nbsp;</p>
            <FormInputDate
              name="saleEndDate"
              control={control}
              minDate={watch('saleStartDate')}
              disabled={!watch('saleStartDate') || watch('hasSaleEndDate')}
              placeholder={t('DD/MM/YYYY')}
              sx={{
                '.css-1x51dt5-MuiInputBase-input-MuiInput-input': {
                  fontSize: '16px',
                },
              }}
              renderInput={params => (
                <TextField
                  color="info"
                  size="small"
                  variant="outlined"
                  {...params}
                  sx={{
                    width: 150,
                    background: '#fff',
                    '.MuiInputBase-root': {
                      paddingRight: '0px',
                    },
                    '.MuiIconButton-root': {
                      marginRight: '0px',
                    },
                    input: {
                      paddingRight: '0px!important',
                    },
                    '& .MuiSvgIcon-root': {
                      fill: '#0F7F85 !important',
                    },
                  }}
                />
              )}
            />
          </Box>
          <FormControlLabel
            control={
              <CustomCheckbox
                checked={watch('hasSaleEndDate')}
                setValue={setValue}
                name="hasSaleEndDate"
                sx={{ borderRadius: '100px' }}
              />
            }
            label={t('No closing date')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Validity Period')}
          </Typography>
          <FormInputText
            control={control}
            sx={{ width: '320px' }}
            rules={{ required: true }}
            name="usagePeriod"
            placeholder={t('Type in the period')}
          />
          <FormControlLabel
            sx={{ ml: 1, fontWeight: 400 }}
            control={
              <CustomRadioBox checked={usagePeriodType === true} onChange={() => handleChangePeriodType(true)} />
            }
            label={t('Month(s)')}
          />
          <FormControlLabel
            sx={{ ml: 1, fontWeight: 400 }}
            control={
              <CustomRadioBox checked={usagePeriodType === false} onChange={() => handleChangePeriodType(false)} />
            }
            label={t('Day(s)')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Instructor(s)')}
          </Typography>
          <Button
            sx={{
              background: '#707070',
              '&:hover': { backgroundColor: '#707070' },
              minWidth: '150px',
              height: '52.69px',
              borderRadius: '10px',
            }}
            variant="contained">
            {t('Upload Instructor')}
          </Button>
          <FormInputSearch
            control={control}
            sx={{
              width: '310px',
              marginLeft: '20px',
              '.MuiAutocomplete-endAdornment': {
                top: 'calc(50% - 10px)',
              },
            }}
            rules={{ required: true }}
            handleChange={handlechage}
            options={filterTrainers(trainers, ticketData.trainerIdsList)}
            placeholder={t('Type the client’s name')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography sx={{ width: '8%' }}></Typography>
          <div
            style={{
              border: 'solid 1px #ddd',
              borderRadius: '5px',
              width: '480px',
              minHeight: '95px',
              height: 'auto',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, m: 1 }}>
              {ticketData.trainerIdsList.map(tr => (
                <Box key={tr.trainerId} sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                  <Typography
                    sx={{
                      background: '#fafbfc',
                      borderRadius: '20px',
                      fontSize: '13px',
                      padding: '8px 20px 7px',
                      color: theme.palette.primary.main,
                    }}>
                    {tr.name}
                  </Typography>
                  <CancelIcon
                    color="info"
                    onClick={() => removeTrainer(tr.id)}
                    sx={{
                      '&:hover': {
                        background: '#fff',
                        color: '#0F7F85',
                        cursor: 'pointer',
                      },
                    }}
                  />
                </Box>
              ))}
            </Box>
          </div>
        </Box>
      </Box>
      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box sx={{ m: 3 }}>
        <Typography sx={{ mt: 2, mb: 2, fontSize: '16px', fontWeight: 500 }}>{t('Upload class videos')}</Typography>
        <Box>
          <Box>
            <Typography sx={{ width: '100%', fontWeight: 500 }}>{t('Class pass video')}</Typography>
            <Box
              sx={{
                mt: '11px',
                border: '1px solid #ddd',
                width: '1000px',
                padding: '30px 20px 15px',
                pt: '30px',
                pl: '20px',
                borderRadius: '5px',
              }}>
              {videosOfCourses?.map((videoCourse, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      width: '960px',
                      mb: '10px',
                      border: '1px dashed #ddd',
                      background: '#fafbfc',
                      borderRadius: '5px',
                      pt: '20px',
                      pr: '30px',
                      pb: '20px',
                    }}>
                    <Box sx={{ borderRight: '1px solid #e7e7e7', mr: '40px', pr: '40px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 500, ml: 3, mr: 3 }}>{t('Title')}</Typography>
                        <FormInputText
                          control={control}
                          value={videoCourse.title}
                          onChange={handleVideoCoursesInfo}
                          // rules={{ required: true }}
                          sx={{
                            ml: 'auto',
                            width: '370px',
                            height: '40px',
                            '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                              fontSize: '14px',
                              color: '#111',
                            },
                          }}
                          name={`title-${index}`}
                          inputProps={{ maxLength: 15 }}
                          placeholder={t('Curriculum')}
                        />
                        <Typography
                          sx={{
                            fontSize: '11px',
                            alignSelf: 'flex-end',
                            textAlign: 'right',
                            width: '35px',
                            pl: 1,
                          }}>
                          ({videoCourse.title.length}/15)
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                        <Typography sx={{ fontWeight: 500, ml: 3, mr: 3 }}>{t('Overview')}</Typography>
                        <FormInputText
                          control={control}
                          value={videoCourse.desc}
                          onChange={handleVideoCoursesInfo}
                          // rules={{ required: true }}
                          sx={{
                            ml: 'auto',
                            width: '370px',
                            height: '40px',
                            '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                              fontSize: '14px',
                              color: '#111',
                            },
                          }}
                          name={`desc-${index}`}
                          inputProps={{ maxLength: 40 }}
                          placeholder={t('Curriculum')}
                        />
                        <Typography
                          sx={{
                            fontSize: '11px',
                            alignSelf: 'flex-end',
                            textAlign: 'right',
                            width: '35px',
                            pl: 1,
                          }}>
                          ({videoCourse.desc.length}/40)
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Box>
                        <Box>
                          <Box
                            sx={{
                              background: '#C1DBDE',
                              width: '144px',
                              height: '108px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              overflow: 'hidden',
                              borderRadius: '12px',
                            }}>
                            <label
                              htmlFor={`videoCourse-${index}`}
                              style={{
                                cursor: 'pointer',
                                height: '100%',
                                width: '100%',
                                position: 'relative',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}>
                              {videoCourse.video?.url || videoCourse.video?.file ? (
                                <>
                                  <video src={videoCourse.video?.url} style={{ height: '100%' }} />
                                  <Button
                                    style={{
                                      position: 'absolute',
                                      display: 'flex',
                                      minWidth: 'unset',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      backgroundColor: '#fff',
                                      bottom: '7px',
                                      right: '7px',
                                      padding: '4px',
                                    }}
                                    onClick={e => deleteVideoCourseFile(e, index)}>
                                    <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                                  </Button>
                                </>
                              ) : (
                                <img src="/images/icons/video-icon.png" alt="Upload video" />
                              )}
                            </label>
                            <input
                              type="file"
                              id={`videoCourse-${index}`}
                              accept="video/*"
                              style={{ display: 'none' }}
                              onChange={handleUploadVideoCourse}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    {videosOfCourses.length > 1 && (
                      <CloseIcon
                        onClick={() => deleteCourseVideos(index)}
                        sx={{ fontSize: '32px', ml: 20, cursor: 'pointer' }}
                      />
                    )}
                  </Box>
                );
              })}
              <Box
                onClick={addCourseVideo}
                sx={{
                  display: 'flex',
                  columnGap: '10px',
                  '&:hover': {
                    color: theme.palette.primary.main,
                    cursor: 'pointer',
                  },
                }}>
                <ControlPointIcon color="#707070" />
                <Typography>{t('VOD 수업 추가')}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ m: 3 }}>
        <Typography sx={{ mt: 2, mb: 2, fontSize: '16px', fontWeight: 500 }}>{t('Details')}</Typography>

        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '31px' }}>
            <Box>
              <Typography sx={{ width: '100%', fontWeight: 500 }}>{t('Video file')}</Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  border: '1px solid #ddd',
                  height: '245px',
                  width: '293px',
                  mt: 1,
                  mb: 1,
                  borderRadius: '5px',
                }}>
                <Box
                  sx={{
                    background: '#C1DBDE',
                    width: '240px',
                    height: '181px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                  }}>
                  <label
                    htmlFor="video"
                    style={{
                      cursor: 'pointer',
                      height: '100%',
                      width: '100%',
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    {videoFile?.url || videoFile?.file ? (
                      <>
                        <video src={videoFile.url} style={{ height: '100%' }} />
                        <Button
                          style={{
                            position: 'absolute',
                            display: 'flex',
                            minWidth: 'unset',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            bottom: '7px',
                            right: '7px',
                            padding: '4px',
                          }}
                          onClick={e => deleteVideo(e)}>
                          <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </Button>
                      </>
                    ) : (
                      <img src="/images/icons/video-icon.png" alt="Upload video" />
                    )}
                  </label>
                  <input
                    type="file"
                    id="video"
                    accept="video/*"
                    style={{ display: 'none' }}
                    onChange={handleUploadVideo}
                  />
                </Box>
              </Box>
            </Box>

            <Box>
              <Typography sx={{ width: '100%', fontWeight: 500 }}>{t('Video thumbnail')}</Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  border: '1px solid #ddd',
                  height: '245px',
                  width: '293px',
                  mt: 1,
                  mb: 1,
                  borderRadius: '5px',
                }}>
                <Box
                  sx={{
                    background: '#C1DBDE',
                    width: '240px',
                    height: '181px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                  }}>
                  <label
                    htmlFor="video-thumbnail"
                    style={{
                      cursor: 'pointer',
                      height: '100%',
                      width: '100%',
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    {videoThumbnail?.url || videoThumbnail?.file ? (
                      <>
                        <img src={videoThumbnail.url} style={{ height: '100%' }} />
                        <Button
                          style={{
                            position: 'absolute',
                            display: 'flex',
                            minWidth: 'unset',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            bottom: '7px',
                            right: '7px',
                            padding: '4px',
                          }}
                          onClick={e => deleteVideoThumbnail(e)}>
                          <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </Button>
                      </>
                    ) : (
                      <img src="/images/icons/image-icon.png" width={40} height={44} alt="Upload video thumbnail" />
                    )}
                  </label>
                  <input
                    type="file"
                    id="video-thumbnail"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleUploadVideoThumbnail}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box>
          <Typography sx={{ width: '11%', fontWeight: 500 }}>{t('Pass Design')}</Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid #ddd',
              width: '1000px',
              pt: '30px',
              mt: 1,
              borderRadius: '5px',
            }}>
            {ticketData.voucherList.length ? (
              <Box
                className="overscroll"
                sx={{
                  display: 'flex',
                  columnGap: '10px',
                  mx: '20px',
                  pb: '16px', // ml: "10px",
                  // mt: "20px",
                  overflowX: 'auto',
                }}>
                {ticketData.voucherList.map((img, index) => {
                  return (
                    <label htmlFor="imageupload" key={index} style={{ position: 'relative' }}>
                      <img
                        onClick={() => handleSelect(index)}
                        key={index}
                        alt="업로드 한 이미지 영역"
                        src={img.voucherUrl ?? (window.URL || window.webkitURL).createObjectURL(img.voucherImg)}
                        width="240px"
                        height="180px"
                        style={{ objectFit: 'cover' }}
                      />
                      <input
                        type="file"
                        id="imageupload"
                        style={{ display: 'none' }}
                        onChange={e => handleUploadTicketImages(e)}
                      />
                      <Button
                        style={{
                          position: 'absolute',
                          display: 'flex',
                          minWidth: 'unset',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#fff',
                          bottom: '7px',
                          right: '7px',
                          padding: '4px',
                        }}
                        onClick={() => deleteVoucher(index)}>
                        <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                      </Button>
                    </label>
                  );
                })}
              </Box>
            ) : null}
            <Box sx={{ margin: '16px 20px' }}>
              {ticketData.voucherList.length}/{7}
              <Button
                variant="contained"
                component="label"
                sx={{
                  mt: '12px',
                  background: '#707070',
                  '&:hover': { background: '#0F7F85' },
                  borderRadius: '10px',
                  float: 'right',
                }}>
                {t('Upload an image')}
                <input hidden accept="image/*" multiple type="file" onChange={uploadImages} />
              </Button>
              <Typography sx={{ fontSize: '11px', mt: '10px' }}>
                {t(
                  'Uploading images: You may upload maximum 7 images in the PNG or JPEG formats. The suggested maximum size is 8MB, 1200 * 900 px (ratio 4:3). Small and medium size thumbnails will be automatically generated with your uploaded images',
                )}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Typography
          sx={{
            mt: '31px',
            fontWeight: 500,
          }}>
          {t('Create Curriculum')}
        </Typography>
        <Box
          sx={{
            mt: '11px',
            border: '1px solid #ddd',
            width: '1000px',
            padding: '30px 20px 15px',
            pt: '30px',
            pl: '20px',
            borderRadius: '5px',
          }}>
          {ticketData.curList.map((card, index) => (
            <Box
              key={card}
              sx={{
                display: 'flex',
                width: '960px',
                mb: '10px',
                border: '1px dashed #ddd',
                background: '#fafbfc',
                borderRadius: '5px',
              }}>
              <Box sx={{ display: 'flex', margin: '20px' }}>
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                    <Typography>{t('Title')}</Typography>
                    <FormInputText
                      control={control}
                      staticValue={card.title}
                      onChange={e => setCard(e, index)}
                      sx={{
                        ml: 'auto',
                        width: '370px',
                        height: '40px',
                        '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': { fontSize: '14px', color: '#111' },
                      }}
                      name="title"
                      inputProps={{ maxLength: 15 }}
                      placeholder={t('Curriculum')}
                    />
                    <Typography
                      sx={{
                        fontSize: '11px',
                        alignSelf: 'flex-end',
                        textAlign: 'right',
                        width: '35px',
                      }}>
                      ({card.title.length}/15)
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mt: '16px',
                      gap: 2.3,
                    }}>
                    <Typography>{t('Overview')}</Typography>
                    <FormInputText
                      onChange={e => setCard(e, index)}
                      control={control}
                      staticValue={card.outline}
                      name="outline"
                      sx={{ width: '370px' }}
                      inputProps={{ maxLength: '40' }}
                      placeholder={t('Description')}
                      size="large"
                    />
                    <Typography
                      sx={{
                        fontSize: '11px',
                        alignSelf: 'flex-end',
                        textAlign: 'right',
                        width: '39px',
                      }}>
                      ({card.outline.length}/40)
                    </Typography>
                  </Box>
                </Box>
                <div
                  style={{
                    marginLeft: '20px',
                    width: '2px',
                    height: '107px',
                    background: '#ddd',
                  }}></div>
              </Box>
              <Box sx={{ ml: '20px', mt: '24px' }}>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    background: '#707070',
                    '&:hover': { background: '#0F7F85' },
                    borderRadius: '10px',
                    color: '#fff',
                    minWidth: '150px',
                  }}>
                  {t('Upload selected file')}
                  <input hidden accept="image/*" name="curImg" type="file" onChange={e => uploadCardImages(e, index)} />
                </Button>
                {card.fileName ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: '16px' }}>
                    <Button
                      sx={{
                        borderRadius: '15px',
                        background: '#ebebeb',
                        color: '#707070',
                        '&:hover': { backgroundColor: '#ebebeb' },
                        padding: '8px 20px',
                        fontSize: '11px',
                        lineHeight: '11px',
                      }}>
                      {card.fileName}
                    </Button>
                    <CancelIcon
                      onClick={() => deleteCurImage(index)}
                      sx={{ ml: '6px', '&:hover': { color: '#0F7F85' } }}
                      color="info"
                    />
                  </Box>
                ) : null}
              </Box>
            </Box>
          ))}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              margin: '12px 0 34px 20px',
              justifyContent: 'space-between',
            }}>
            {ticketData.curList.length !== 5 ? (
              <Box
                onClick={() => handleAddCard()}
                sx={{
                  display: 'flex',
                  columnGap: '10px',
                  '&:hover': {
                    color: theme.palette.primary.main,
                    cursor: 'pointer',
                  },
                }}>
                <ControlPointIcon color="#707070" />
                <Typography>{t('Add Curriculum')}</Typography>
              </Box>
            ) : (
              <div></div>
            )}
            <Typography
              sx={{
                fontSize: '11px',
                color: '#707070',
                letterSpacing: '-0.28px',
              }}>
              * {t('Up to 5 curriculums')}
            </Typography>
          </Box>
          <Typography sx={{ color: '#707070', fontSize: '11px' }}>
            *{' '}
            {t(
              'We recommend dimensions of 1200 * 900 px (ratio 4:3). Small and medium size thumbnails will be automatically generated with your uploaded images. Images must be either in the JPG or PNG formats',
            )}
          </Typography>
        </Box>

        <Box>
          <Typography
            sx={{
              mt: 3,
              fontWeight: 500,
            }}>
            {t('Class Description')}
          </Typography>
          <Box
            sx={{
              width: '1000px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              mt: 1,
            }}>
            <FormInputCEditor
              setValue={setValue}
              control={control}
              data={ticketData?.classDetail ?? ''}
              name="classDetail"
            />
          </Box>
        </Box>
      </Box>

      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box
        sx={{
          mt: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CustomCheckbox
            color="primary"
            checked={ticketData.whenChecked}
            onChange={e =>
              setTicketData({
                ...ticketData,
                whenChecked: e.target.checked,
              })
            }
          />
          <Typography sx={{ fontSize: '12px' }}>{t('Post')}</Typography>
          <Typography sx={{ ml: 1, fontSize: '12px' }}>
            {t('* By checking this box, you are sharing the description with users')}
          </Typography>
        </Box>
        <Box>
          <Button
            onClick={() => navigate(-1)}
            sx={{
              borderRadius: '12px',
              pl: '35px',
              pr: '35px',
              mr: '6px',
              height: '36px',
              background: '#f7f7f7',
              color: '#9a9a9a',
              border: 'none',
              '&:hover': { background: '#ddd', cursor: 'default' },
            }}>
            {t('Cancel')}
          </Button>
          <Button
            // disabled={loader}
            onClick={handleSubmit(submit)}
            sx={{
              borderRadius: '12px',
              pl: '50px',
              pr: '50px',
              height: '36px',
              background: '#E2F6F7',
              '&:hover': {
                background: '#0F7F85',
                color: '#fff',
                cursor: 'default',
              },
            }}>
            {t('Save')}
          </Button>
        </Box>
      </Box>
    </div>
  );
}

export default CreateVOD;
